import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import styles from './SimpleCheckbox.module.scss';

function SimpleCheckbox(props) {
  const { onChange, disabled, value, checked } = props;

  const handleChange = (event) => {
    const { checked } = event.target;

    if (!disabled && onChange) {
      onChange(checked);
    }
  };

  const counterLabel = () => {
    const { counter } = props;

    if (counter === null) {
      return null;
    }

    return <span className={cn(styles.counter, counter === 0 ? styles.counter_zero : '')}>{counter}</span>;
  };

  return (
    <label className={cn(styles.container, disabled ? styles.disabled : '', props.hidden ? styles.hidden : '')}>
      <input id={value} type="checkbox" value={value} checked={checked} onChange={handleChange} disabled={disabled} />
      <div className={checked ? 'cymbio-checkbox' : 'cymbio-checkbox-outline'} />
      <span className={styles.label}>
        {props.label}
        {counterLabel()}
      </span>
    </label>
  );
}

export default SimpleCheckbox;

SimpleCheckbox.defaultProps = {
  checked: false,
  disabled: false,
  onChange: undefined,
  counter: null,
  hidden: false,
};

SimpleCheckbox.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  label: PropTypes.string.isRequired,
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  counter: PropTypes.number,
  hidden: PropTypes.bool,
};
